import { addStyles } from 'ethcss'
import { grid, item, IStyles } from '../../theme'
import { defaultThemeStyles } from './tabs.theme'
import { colors, font } from 'theme'
const tabsStyles: IStyles = {
    fullContent: {
        ...grid.full,
        ...grid.col,
        ...item.rel,
    },
    tab: {
        ...grid.space,
        ...grid.rowCenter,
        padding: '21px 10px',
        ...item.pointer,
        textAlign: 'center',
        background: `var(--var-module-ui-component-tabs-style-background, ${defaultThemeStyles.background})`,
        color: `var(--var-module-ui-component-tabs-style-textMain, ${defaultThemeStyles.textMain})`,
        borderRadius: '7px',
        marginRight: '10px',
        '&:hover': {
            background: `var(--var-module-ui-component-tabs-style-hoverBackground, ${defaultThemeStyles.hoverBackground})!important`,
            color: `var(--var-module-ui-component-tabs-style-hover, ${defaultThemeStyles.hover})!important`,
        },
        '&:last-child': {
            marginRight: 0,
        },
        textDecoration: 'none',
    },
    tabActive: {
        borderRight: `2px solid transparent`,
        borderBottom: `2px solid transparent`,
        background: `var(--var-module-ui-component-tabs-style-activeBackground, ${defaultThemeStyles.activeBackground})!important`,
        color: `var(--var-module-ui-component-tabs-style-active, ${defaultThemeStyles.active})!important`,
    },
    tabActiveNewDesign: {
        fontWeight: 'bold',
    },
    tabNewDesign: {
        fontFamily: font.regular,
        background: 'none',
        borderBottom: '1px solid var(--var-module-ui-component-table-style-cellBorder, #CFD4E4)',
        borderRight: '1px solid var(--var-module-ui-component-table-style-cellBorder, #CFD4E4)',
        borderTop: '1px solid var(--var-module-ui-component-table-style-cellBorder, #CFD4E4)',
        padding: '10px',
        borderRadius: '0px !important',
        marginRight: '0px !important',
        color: colors.black,
        textTransform: 'uppercase',
        '&:hover': {
            background: 'none !important',
            color: colors.black + '!important',
        },
    },
}

addStyles(tabsStyles)
export default tabsStyles
